import React, { Component } from 'react';
import ReactLoading from 'react-loading';

class LoadingOverlay extends Component {

  render() {
    return (
      <div className="t-modal-backdrop">
        <div className="t-modal-trans">
          <strong>しばらくお待ち下さい</strong>
          <ReactLoading type="bars" />
        </div>

      </div>
    );
  }

}

export default LoadingOverlay;


// WEBPACK FOOTER //
// ./src/components/LoadingOverlay.js